import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { $getRoot } from "lexical"
import { useEffect } from "react"

/**
 * Enforce a single line in the input
 */
export const SingleLinePlugin = () => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerUpdateListener((x) => {
      editor.update(() => {
        const root = $getRoot()
        const paragraphs = root.getChildren()

        // Keep only the first paragraph at all times
        paragraphs.forEach((p, i) => i > 0 && p.remove())
      })
    })
  }, [editor])

  return null
}
